import { Field, reduxForm } from "redux-form";
import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Button, Input } from "expano-components";
import { Modal } from "components";
import { client, getApiErrorMessage } from "utils/api";

const validate = (values) => {
  const errors = {};
  if (!values.name?.trim()) {
    errors.name = "Pole wymagane";
  }
  return errors;
};

const EditDocumentModal = ({
  id,
  refetch,
  handleClose,
  handleSubmit,
  pristine,
  valid,
}) => {
  const [is_submitting, setSubmitting] = useState(false);

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      await client.put(`/document_product_groups/${id}`, values);
      toastr.success("Sukces", "Dodano dokument");
      refetch();
      handleClose();
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      header={{ title: "Edytuj dokument" }}
      handleClose={handleClose}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            disabled={pristine || !valid || is_submitting}
            text={is_submitting ? "Proszę czekać…" : "Zapisz"}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="submit" style={{ display: "none" }} />
        <Field label="Nazwa dokumentu" name="name" component={Input} />
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "edit-document-product-group",
  validate,
  enableReinitialize: true,
})(EditDocumentModal);
